import { useQuery } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { getEntitlementsData } from "../api/entitlements-service";
export const usePermissionsQuery = (token) => {
    return useQuery({
        enabled: !!token,
        gcTime: 0,
        queryFn: () => {
            return getEntitlementsData();
        },
        queryKey: ["permissions", token],
        refetchInterval: refetchApiInterval,
        retry: 2
    });
};
